import { IParts, IRequestReportDetails } from '@module/shared';

export async function FetchCustomerReportData(sparePartsUploadDetailsID: string) {
    const url = `${environmentSettings.webapiUrl}/v1/Request/guest/` + sparePartsUploadDetailsID;
    const headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    const response = await fetch(url, { headers, cache: 'no-store' });
    const contentType = response.headers.get('content-type');
    if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
      const reportData: IRequestReportDetails = await response.json();
      const parts = await GetParts(reportData.sparePartsUploadDetailsID);
      reportData.matchedParts = parts.matchedSpareParts;
      reportData.unMatchedParts = parts.unmatchedSpareParts;
      return reportData;
    } else {
      return Promise.reject({status: response.status, statusText: response.statusText});
    }
}

export async function GetParts(sparePartsUploadDetailsID: string): Promise<IParts> {
  const response = await FetchParts(sparePartsUploadDetailsID);
  const contentType = response.headers.get('content-type');
 
  if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
    const json = await response.json();
    return json;
    } else {
      return Promise.reject({status: response.status, statusText: response.statusText});
    }
}

export function FetchParts(sparePartsUploadDetailsID: string): Promise<Response> {
  const headers = new Headers();
  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-cache');
  const paramUrl = 'sparePartsUploadDetailsID=' + sparePartsUploadDetailsID;
  return fetch(`${environmentSettings.webapiUrl + '/v2/Request/guest/parts?' + paramUrl}`, { headers, cache: 'no-store' });
}
